import { device, mq } from "lib/media-query";
import React from "react";
import styled from "styled-components";

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px 8px;

    ${mq.from(device.TABLET_LANDSCAPE)`
    padding: 16px 0;
  `};
`;

const Button = styled.button`
    border: 0;
    background: none;
    color: ${({ theme }) => theme.colors.secondary[700]};
    text-transform: uppercase;
    padding: 0 1px;
    cursor: pointer;
`;

const Icon = styled.span`
    display: block;
    float: right;
    font-weight: bold;
    font-size: 1.8rem;
    line-height: 1rem;
    padding: 2px 0 0 8px;
`;

export const AdvancedSearchButton = ({ onClick = () => {}, expanded = false }) => {
    const buttonText = expanded ? "Verberg Uitgebreid Zoeken" : "Uitgebreid Zoeken";
    const buttonIcon = expanded ? "-" : "+";
    return (
        <ButtonContainer>
            <Button onClick={onClick}>
                {buttonText} <Icon>{buttonIcon}</Icon>
            </Button>
        </ButtonContainer>
    );
};
